import { useQuery } from 'react-query';

export default (providerId) => {
  const { data: { data } = {}, isLoading, isSuccess } = useQuery(['GET', `/apis/v2/providers/${providerId}/profile`, {}]);

  return { data: data?.attributes || null, isLoading, isSuccess };
};
